import { useEffect, useState } from 'react';

const useLogoProportions = (logoUrl: string | null) => {
  const [isLogoHorizontal, setIsHorizontal] = useState<boolean | null>(true);

  useEffect(() => {
    if (logoUrl) {
      const img = new Image();
      img.src = logoUrl;
      img.onload = () => {
        const isHorizontal = img.width > img.height;
        setIsHorizontal(isHorizontal);
      };
    }
  }, [logoUrl]);

  return { isLogoHorizontal };
};

export default useLogoProportions;
